import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import {
  FiSearch, FiBox, FiFileText, FiCpu,
  FiZap, FiDollarSign, FiColumns, FiTool, FiCreditCard,
} from 'react-icons/fi';

const features = [
  {
    icon: <FiSearch />,
    title: 'Smart qidirish',
    desc: "Xona soni, narx, hudud va boshqa filtrlar orqali orzuingizdagi kvartira'ni bir zumda toping.",
  },
  {
    icon: <FiBox />,
    title: '3D planirovka',
    desc: "Kvartira ichini 360° ko'rinishda ko'ring. Har bir xona va burchakni batafsil o'rganing.",
  },
  {
    icon: <FiFileText />,
    title: 'Online shartnoma',
    desc: "Faqat 5 bosqichda shartnomangizni onlayn tuzing. Hech qayerga borish shart emas.",
  },
  {
    icon: <FiCpu />,
    title: 'AI yordamchi',
    desc: "Sun'iy intellekt chat-bot sizga mos kvartira tanlashda 24/7 yordam beradi.",
  },
  {
    icon: <FiZap />,
    title: 'Qaynoq takliflar',
    desc: "Eng yaxshi aksiyalar va maxsus takliflardan birinchi bo'lib xabardor bo'ling.",
  },
  {
    icon: <FiDollarSign />,
    title: "To'lov kalkulyatori",
    desc: "Ipoteka, oylik to'lov va umumiy xarajatlarni bir necha soniyada hisoblang.",
  },
  {
    icon: <FiColumns />,
    title: 'Taqqoslash',
    desc: "Bir nechta kvartira'ni yonma-yon qo'yib, narx, maydon va boshqa ko'rsatkichlarni solishtiring.",
  },
  {
    icon: <FiTool />,
    title: 'Qurilish jarayoni',
    desc: "Tanlagan loyihangiz qurilish jarayonini foiz (%) ko'rinishida real vaqtda kuzating.",
  },
  {
    icon: <FiCreditCard />,
    title: 'Kredit arizasi',
    desc: "6 ta bank bilan hamkorlikda kredit arizangizni ilova ichidan to'g'ridan-to'g'ri yuboring.",
  },
];

const Features = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  const container = {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.08 },
    },
  };

  const card = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
  };

  return (
    <section className="features-section section-container" id="features" ref={ref}>
      <div className="features-header">
        <span className="section-tag">Imkoniyatlar</span>
        <h2 className="section-title">
          Bitta ilovada <span className="gold-text">hamma narsa</span>
        </h2>
        <p className="section-desc">
          OSTONA sizga kvartira qidirish, ko'rish, taqqoslash va sotib olish
          uchun barcha kerakli vositalarni taqdim etadi.
        </p>
      </div>

      <motion.div
        className="features-grid"
        variants={container}
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
      >
        {features.map((f, i) => (
          <motion.div className="feature-card" key={i} variants={card}>
            <div className="feature-icon">{f.icon}</div>
            <h3>{f.title}</h3>
            <p>{f.desc}</p>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default Features;
